export default __webpack_public_path__ + "static/media/ImgBooklet.a16a95a2.jpg";